import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createCardiologyDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterCardiologyFormSchema } from "./schema";
import { DischargeLetterCardiologyFormSections } from "./sections";

export const getDischargeLetterCardiologyFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        allergies: value?.allergies ?? "",
        anamnesis: value?.anamnesis ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        ecg: value?.ecg ?? "",
        physical_status: value?.physical_status ?? "",
        previous_diagnoses: value?.previous_diagnoses ?? "",
        social_history: value?.social_history ?? "",
        therapy_and_course: value?.therapy_and_course ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameCarido,
      pdfCreator: createCardiologyDischargeLetterPdf,
    },
    schema: DischargeLetterCardiologyFormSchema,
    sections: DischargeLetterCardiologyFormSections,
  };
};
